import { Api } from '@axiom/ui';
import type { Candidate, Certification } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateCertificationsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  async createCertification(
    candidateId: Candidate['id'],
    certification: Partial<Certification>
  ) {
    return super.write<{ data: Certification }>({
      endpoint: `/candidates/${candidateId}/certifications`,
      body: certification,
      method: 'POST',
    });
  }

  async updateCertification(
    id: Certification['id'],
    certification: Partial<Certification>
  ) {
    return super.write<{ data: Certification }>({
      endpoint: `/certifications/${id}`,
      body: certification,
      method: 'PATCH',
    });
  }

  async deleteCertification(id: Certification['id']) {
    return super.write<{ data: Certification }>({
      endpoint: `/certifications/${id}`,
      method: 'DELETE',
    });
  }
}

export const CandidateCertificationsApi = new CandidateCertificationsApiClass();
